<template>
  <div style="margin-bottom: 20px;">
    <label class="label">{{inputName}}</label>
    <label
      class="label"
      style="color: grey;font-size: 0.9rem;font-weight: 400;"
    >Select any that apply.</label>
    <div class="columns is-gapless is-multiline" style="margin-top: 10px;">
      <div class="column is-half" v-for="input in inputs" v-bind:key="input.text">
        <div class="choice" @click="selectInput(input)" :class="input.selected ? 'selected': ''">
          <div class="columns is-gapless is-multiline is-mobile is-vcentered">
            <div class="column is-one-fifth">
              <transition name="slideb" mode="out-in">
                <span class="icon is-medium" v-if="!input.selected" key="unchecked">
                  <i class="far fa-2x fa-circle" style="color: grey;"></i>
                </span>
                <span class="icon is-medium" v-if="input.selected" key="checked">
                  <i class="far fa-2x fa-check-circle" style="color: #1a689b;"></i>
                </span>
              </transition>
            </div>
            <div class="column">
              <p>{{input.text}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="help is-danger" v-if="field.error">{{field.error}}</p>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "Choices",
  model() {
    return { value: "", error: "", typed: false };
  },
  props: {
    inputField: Object,
    inputName: String,
    inputType: String,
    options: Array
  },
  data() {
    return {
      field: this.inputField,
      inputs: []
    };
  },
  computed: {},
  methods: {
    modified() {
      // this.field.typed = true;
      let arr = []
      this.inputs.forEach(input => {
        if (input.selected) {
          arr.push(input.text)
        }
      });
      this.setValue(arr)
      this.validate();
    },
    validate() {
      this.field.error = null;
      let valid = false;
      this.inputs.forEach(input => {
        if (input.selected) {
          valid = true;
        }
      });
      if (valid == false) {
        this.field.error = "Please select at least one option.";
      }
      return this.field.error == null;
    },
    setValue(s) {
      this.field.value = s;
      // this.modified();
    },
    selectInput(input) {
      input.selected = !input.selected;
      this.modified()
      this.validate();
    }
  },
  mounted: function() {
    let self = this;
    this.options.forEach(option => {
      let newObj = {
        selected: false,
        text: option,
        value: option
      };
      self.inputs.push(newObj);
    });
  }
};
</script>

<style scoped>
.choice {
  padding: 15px;
  transition: all 0.5s;
  margin: 5px !important;
  cursor: pointer;
  border: 1px solid #1a689b;
  border-radius: 5px;
}
.selected {
  background: #f0f4ff;
}
</style>